export default __webpack_public_path__ + "static/media/trylleby-property-26.628c2175.jpg";